import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-source-code-modal',
  templateUrl: './source-code-modal.component.html',
  styleUrls: ['./source-code-modal.component.scss'],
  standalone: false
})
export class SourceCodeModalComponent {
  @Input() srcCode: string;

  constructor(public modal: NgbActiveModal) {}

  @ViewChild('srcCodeTextArea') srcCodeTextArea: ElementRef<HTMLTextAreaElement>;

  exportSrcCode() {
    const newSourceCode = this.srcCodeTextArea.nativeElement.value;
    this.modal.close(newSourceCode);
  }
}
